import { render, staticRenderFns } from "./TaskConfig.vue?vue&type=template&id=7e996f7d&scoped=true"
import script from "./TaskConfig.vue?vue&type=script&lang=js"
export * from "./TaskConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskConfig.vue?vue&type=style&index=0&id=7e996f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e996f7d",
  null
  
)

export default component.exports